import React from 'react';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';

import * as s from './AdvertisingLabel.css';

/**
 * Лейбл "Партнёрский материал"
 */
export const AdvertisingLabel = () => (
  <div className={s['wrapper']}>
    <IconFunctionalSuccess16 />
    Партнёрский материал
  </div>
);
